// Actions
export const FETCH_ANALYZER_CHOICES = 'ACTS/FETCH_ANALYZER_CHOICES';
export const FETCH_ANALYZER_CHOICES_STARTED =
    'ACTS/FETCH_ANALYZER_CHOICES_STARTED';
export const FETCH_ANALYZER_CHOICES_SUCCESSFUL =
    'ACTS/FETCH_ANALYZER_CHOICES_SUCCESSFUL';
export const FETCH_ANALYZER_CHOICES_FAILED =
    'ACTS/FETCH_ANALYZER_CHOICES_FAILED';

// Initial state for reducer
const initialState = {
    loading: false,
    response: null,
    error: null,
};

// Reducer(s)
export default function fetchForestEstimateAnalyzerChoicesReducer(
    state = initialState,
    action,
) {
    switch (action.type) {
        case FETCH_ANALYZER_CHOICES_STARTED:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ANALYZER_CHOICES_SUCCESSFUL:
            return {
                ...state,
                loading: false,
                response: action.response,
                error: null,
            };
        case FETCH_ANALYZER_CHOICES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}

// Action creators
export const fetchForestEstimateAnalyzerChoices = query => ({
    type: FETCH_ANALYZER_CHOICES,
    query,
});
